import React, { useEffect, useRef } from "react";
import "./DynamicImage.scss";

// Libraries and Packages
import { motion, useInView } from "framer-motion";

// Utils
import { useDynamicImageControls } from "./DynamicImageUtils";

function DynamicImage({ title = [], image }) {
  // State
  const {
    controlsDynamicNoise,
    controlsDynamicImage,
    controlsDynamicTitle,
    handleMouseDown,
    handleMouseMove,
    handleMouseLeave,
  } = useDynamicImageControls();

  // Ref
  const refServiceCardTitle = useRef(null);

  const isServiceCardTitleInView = useInView(refServiceCardTitle, {
    once: false,
  });

  // Effect
  useEffect(() => {
    if (isServiceCardTitleInView) {
      controlsDynamicTitle.start({
        y: 0,
        opacity: 1,
        transition: { duration: 1, delay: 0.5 },
      });
    }
  }, [isServiceCardTitleInView, controlsDynamicTitle]);

  return (
    <div
      className="dynamicImage"
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseDown}
      onMouseLeave={handleMouseLeave}
    >
      {/* Title */}
      {title.length !== 0 && (
        <motion.div
          className="dynamicImage__title"
          ref={refServiceCardTitle}
          initial={{ opacity: 0, y: 75 }}
          animate={controlsDynamicTitle}
        >
          {title.map((item, i) => {
            return <div key={i}>{item}</div>;
          })}
        </motion.div>
      )}

      {/* Overlay */}
      <div className="dynamicImage__overlay"></div>
      {/* Noise */}
      <motion.div
        className="dynamicImage__noise"
        initial={{ opacity: 0 }}
        animate={controlsDynamicNoise}
      ></motion.div>
      {/* Image */}
      <motion.div
        className="dynamicImage__image"
        initial={{ x: 0, y: 0, scale: 1 }}
        animate={controlsDynamicImage}
      >
        <img src={image} alt="" />
      </motion.div>
    </div>
  );
}

export default DynamicImage;
